import {
	Avatar,
	Box,
	Button,
	CircularProgress,
	CircularProgressLabel,
	Flex,
	Grid,
	Icon,
	Progress,
	SimpleGrid,
	Spacer,
	Stack,
	Stat,
	StatHelpText,
	StatLabel,
	StatNumber,
	Table,
	Tbody,
	Text,
	Th,
	Thead,
	Tr,
	keyframes,
} from '@chakra-ui/react';
// Styles for the circular progressbar
import medusa from 'assets/img/cardimgfree.png';
// Custom components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import BarChart from 'components/Charts/BarChart';
import LineChart from 'components/Charts/LineChart';
import IconBox from 'components/Icons/IconBox';
// Icons
import { CartIcon, DocumentIcon, GlobeIcon, RocketIcon, StatsIcon, WalletIcon } from 'components/Icons/Icons.js';
import DashboardTableRow from 'components/Tables/DashboardTableRow';
import TimelineRow from 'components/Tables/TimelineRow';
import React, { useState, useEffect } from 'react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { BiHappy } from 'react-icons/bi';
import { BsArrowRight } from 'react-icons/bs';
import { IoCheckmarkDoneCircleSharp, IoEllipsisHorizontal } from 'react-icons/io5';
import { FaCheckCircle, FaExclamationCircle, FaUserShield, FaGavel, FaUserTie, FaBalanceScale, FaBook } from 'react-icons/fa';
import Loading from 'misc/Loading';
import { Link } from 'react-router-dom';
import moment from 'moment';
import config from 'config';
import TableMyArrests from 'components/Tables/TableMyArrests';
// Data
import {
	barChartDataDashboard,
	barChartOptionsDashboard,
	lineChartDataDashboard,
	lineChartOptionsDashboard
} from 'variables/charts';
import { dashboardTableData, timelineData } from 'variables/general';
import Stats_latestArrests from 'components/Tables/stats_latestArrests';

// Api service
import { useFetchData, usePostData } from "apiService";
import TableUsersOnDuty from 'components/Tables/TableUsersOnDuty';
import Cookies from 'js-cookie';
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';

import useCustomToast from 'components/Toast/useCustomToast';

// Animations
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const countUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
`;

export default function Dashboard() {


	const [isLoading, setIsLoading] = useState(true);
	const { data: statsLines } = useFetchData('stats');
	const { data: currentUsers } = useFetchData('users/0');
	const { data: usersOnDuty } = useFetchData('usersOnDuty');
	const { data: myArrestsInValidation } = useFetchData('myArrestsInValidation');
	const [currentUser, setCurrentUser] = useState(null);
	const [stats, setStats] = useState(null);
	const [usersDuty, setUsersDuty] = useState([]);
	const { info } = useCustomToast();

	// Stats
	const { data: lastArrests } = useFetchData('latestArrests');
	const { data: nbrArrestsLastMonthPerDay } = useFetchData('nbrArrestsLastMonth');
	const [totalArrestsLast30days, setTotalArrestsLast30days] = useState(0);

	// Popup for new version
	const [isNewVersion, setIsNewVersion] = useState(false);

	useEffect(() => {
		// Scroll to the top
		window.scrollTo(0, 0);

		// Check if the user had already seen the popup for news
		if (!config.version) return;
		if (config.displayPopup) {
			const currentVersion = config.version;
			const storedVersion = Cookies.get('appVersion');

			if (storedVersion !== currentVersion) {
				setIsNewVersion(true);
			}
		}
	}, []);

	const closeModal = (updateCookie) => {
		setIsNewVersion(false);
		if (updateCookie) {
			Cookies.set('appVersion', config.version, { expires: 365 });
		}
	};

	useEffect(() => {
		if (usersOnDuty && usersOnDuty.length > 0) {
			setUsersDuty(usersOnDuty);
		}
	}, [usersOnDuty]);

	useEffect(() => {
		if (nbrArrestsLastMonthPerDay) {
			let total = 0;
			nbrArrestsLastMonthPerDay.forEach((day) => {
				total += day.Total_Arrests;
			});
			setTotalArrestsLast30days(total);
		}
	}, [nbrArrestsLastMonthPerDay]);

	useEffect(() => {
		setStats(statsLines[0]);
	}, [statsLines]);

	useEffect(() => {
		setCurrentUser(currentUsers[0]);
	}, [currentUsers]);

	useEffect(() => {
		if (stats && currentUser) {
			setIsLoading(false);
		}
	}, [stats, currentUser]);

	if (isLoading) return <Loading />;

	const stats_showOnDuty = async () => {
		info('💥 Bientôt disponible !', 'Cette fonctionnalité n\'est pas encore disponible 😉');
	};

	const stats_showArrests = async () => {
		info('💥 Bientôt disponible !', 'Cette fonctionnalité n\'est pas encore disponible 😉');
	};

	const stats_showCitizens = async () => {
		info('💥 Bientôt disponible !', 'Cette fonctionnalité n\'est pas encore disponible 😉');
	};

	const stats_showUsers = async () => {
		info('💥 Bientôt disponible !', 'Cette fonctionnalité n\'est pas encore disponible 😉');
	};

	return (
		<>
			{/* POP-UP FOR NEW VERSION INFORMATIONS */}
			{isNewVersion && (
				<Modal isOpen={isNewVersion} onClose={() => closeModal(false)} width='90%' size='xl'>
					<ModalOverlay />
					<ModalContent>
						<ModalHeader>🔥Nouvelle mise à jour {config.version} 🔥</ModalHeader>
						<ModalCloseButton />
						<ModalBody>
							Une nouvelle mise à jour a été déployée pour le bonheur de tous 😊<br />
							<br />
							🚀 Nouveautés : <br />
							- Affichage de cette pop-up pour informer des nouvelles versions et de leurs nouveautés.<br />
							- Ajout de logs des services hebdomadaires pour le personnel dans la section <b>Logs des services</b><br />
							- Ajout d'un système de classement par dossier pour les procès-verbaux des citoyens.<br />
							- Mise en place d'un système de casier judiciaire pour les citoyens, accessible aux magistrats.<br />

							<br />
							🔥 Améliorations : <br />
							- Modification de termes spécifiques aux métiers.<br />
							- L'identifiant des procès-verbaux commence désormais par <b>4500</b> au lieu de <b>45000</b><br />
							- Les magistrats ont désormais la capacité de rédiger des procès-verbaux.<br />
							- Vous pouvez désormais bénéficier d'une réduction sur votre abonnement grâce au parrainage, disponible dans la section <b>Configuration</b><br />

							<br />
							🐞 Corrections : <br />
							- Correction de bugs mineurs <br />
							- Améliorations de la stabilité de l'application <br />

							<br />
							🔗 Si vous rencontrez des problèmes ou avez des idées d'améliorations, n'hésitez pas à nous les communiquer en cliquant sur le bouton <b>Signaler</b> en haut de l'écran ! 😉
						</ModalBody>
						<ModalFooter>
							<Button colorScheme="blue" mr={3} onClick={() => closeModal(true)}>
								J'ai compris
							</Button>
						</ModalFooter>
					</ModalContent>
				</Modal>
			)}

			{/* DASHBOARD */}
			<Flex flexDirection='column' pt={{ base: '120px', md: '75px' }}>
				<SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px'>
					{/* MiniStatistics Card - Policiers en service */}
					<Card 
						minH='68px'
						position="relative"
						overflow="hidden"
						animation={`${fadeInUp} 0.5s ease-out`}
						transition="all 0.3s ease"
						_hover={{ 
							boxShadow: '0 12px 40px rgba(139, 92, 246, 0.2)',
						}}
						_before={{
							content: '""',
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							height: '3px',
							bg: 'linear-gradient(90deg, #22c55e, #14b8a6)',
							borderRadius: '20px 20px 0 0',
						}}
					>
						<CardBody>
							<Flex flexDirection='row' align='center' justify='center' w='100%'>
								<Stat me='auto'>
									<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px' whiteSpace="nowrap">
										Policiers en service
									</StatLabel>
									<Flex>
										<StatNumber 
											fontSize='2xl' 
											color='#fff' 
											fontWeight='bold'
											animation={`${countUp} 0.6s ease-out`}
										>
											{stats ? stats.nbr_on_duty : '0'}
										</StatNumber>
									</Flex>
								</Stat>
								<IconBox 
									as='box' 
									h={'42px'} 
									w={'42px'} 
									bg='linear-gradient(135deg, #22c55e 0%, #14b8a6 100%)' 
									boxShadow="0 4px 15px rgba(34, 197, 94, 0.4)"
									animation={`${float} 3s ease-in-out infinite`}
								>
									<FaUserShield size={18} color='#fff' />
								</IconBox>
							</Flex>
						</CardBody>
					</Card>
					
					{/* MiniStatistics Card - Procès-verbaux */}
					<Card 
						minH='68px'
						position="relative"
						overflow="hidden"
						animation={`${fadeInUp} 0.5s ease-out 0.1s both`}
						transition="all 0.3s ease"
						_hover={{ 
							boxShadow: '0 12px 40px rgba(139, 92, 246, 0.2)',
						}}
						_before={{
							content: '""',
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							height: '3px',
							bg: 'linear-gradient(90deg, #8b5cf6, #a855f7)',
							borderRadius: '20px 20px 0 0',
						}}
					>
						<CardBody>
							<Flex flexDirection='row' align='center' justify='center' w='100%'>
								<Stat me='auto'>
									<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px' whiteSpace="nowrap">
										Procès-verbaux rédigés
									</StatLabel>
									<Flex>
										<StatNumber 
											fontSize='2xl' 
											color='#fff'
											fontWeight='bold'
											animation={`${countUp} 0.6s ease-out 0.1s both`}
										>
											{stats ? stats.nbr_arrest : '0'}
										</StatNumber>
									</Flex>
								</Stat>
								<IconBox 
									as='box' 
									h={'42px'} 
									w={'42px'} 
									bg='linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%)' 
									boxShadow="0 4px 15px rgba(139, 92, 246, 0.4)"
									animation={`${float} 3s ease-in-out infinite 0.5s`}
								>
									<FaGavel size={18} color='#fff' />
								</IconBox>
							</Flex>
						</CardBody>
					</Card>
					
					{/* MiniStatistics Card - Individus */}
					<Card
						minH='68px'
						position="relative"
						overflow="hidden"
						animation={`${fadeInUp} 0.5s ease-out 0.2s both`}
						transition="all 0.3s ease"
						_hover={{ 
							boxShadow: '0 12px 40px rgba(139, 92, 246, 0.2)',
						}}
						_before={{
							content: '""',
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							height: '3px',
							bg: 'linear-gradient(90deg, #06b6d4, #0ea5e9)',
							borderRadius: '20px 20px 0 0',
						}}
					>
						<CardBody>
							<Flex flexDirection='row' align='center' justify='center' w='100%'>
								<Stat>
									<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px' whiteSpace="nowrap">
										Individus recensés
									</StatLabel>
									<Flex>
										<StatNumber 
											fontSize='2xl' 
											color='#fff'
											fontWeight='bold'
											animation={`${countUp} 0.6s ease-out 0.2s both`}
										>
											{stats ? stats.nbr_citizens : '0'}
										</StatNumber>
									</Flex>
								</Stat>
								<Spacer />
								<IconBox 
									as='box' 
									h={'42px'} 
									w={'42px'} 
									bg='linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%)' 
									boxShadow="0 4px 15px rgba(6, 182, 212, 0.4)"
									animation={`${float} 3s ease-in-out infinite 1s`}
								>
									<FaBook size={18} color='#fff' />
								</IconBox>
							</Flex>
						</CardBody>
					</Card>
					
					{/* MiniStatistics Card - Effectif */}
					<Card
						minH='68px'
						position="relative"
						overflow="hidden"
						animation={`${fadeInUp} 0.5s ease-out 0.3s both`}
						transition="all 0.3s ease"
						_hover={{ 
							boxShadow: '0 12px 40px rgba(139, 92, 246, 0.2)',
						}}
						_before={{
							content: '""',
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							height: '3px',
							bg: 'linear-gradient(90deg, #f97316, #fb923c)',
							borderRadius: '20px 20px 0 0',
						}}
					>
						<CardBody>
							<Flex flexDirection='row' align='center' justify='center' w='100%'>
								<Stat me='auto'>
									<StatLabel fontSize='sm' color='gray.400' fontWeight='bold' pb='2px' whiteSpace="nowrap">
										Effectif
									</StatLabel>
									<Flex>
										<StatNumber 
											fontSize='2xl' 
											color='#fff' 
											fontWeight='bold'
											animation={`${countUp} 0.6s ease-out 0.3s both`}
										>
											{stats ? stats.nbr_users : '0'}
										</StatNumber>
									</Flex>
								</Stat>
								<IconBox 
									as='box' 
									h={'42px'} 
									w={'42px'} 
									bg='linear-gradient(135deg, #f97316 0%, #fb923c 100%)' 
									boxShadow="0 4px 15px rgba(249, 115, 22, 0.4)"
									animation={`${float} 3s ease-in-out infinite 1.5s`}
								>
									<FaUserTie size={18} color='#fff' />
								</IconBox>
							</Flex>
						</CardBody>
					</Card>
				</SimpleGrid>
				
				{/* Welcome Card */}
				<Card
					mt='24px'
					p='0px'
					gridArea={{ md: '1 / 1 / 2 / 3', '2xl': 'auto' }}
					bgImage={null}
					bgSize='cover'
					bgPosition='50%'
					animation={`${fadeInUp} 0.5s ease-out 0.5s both`}
					position="relative"
					overflow="hidden"
					transition="all 0.3s ease"
					_hover={{
						boxShadow: '0 15px 50px rgba(139, 92, 246, 0.15)',
					}}
				>
					<CardBody w='100%' h='100%'>
						<Flex flexDirection={{ sm: 'column', lg: 'row' }} w='100%' h='100%'>
							<Flex align='center' justify='center' h='100%' ml={5} mt={5}>
								<Box
									position="relative"
									_before={{
										content: '""',
										position: 'absolute',
										top: '-4px',
										left: '-4px',
										right: '-4px',
										bottom: '-4px',
										borderRadius: '16px',
										bg: 'linear-gradient(135deg, #8b5cf6, #06b6d4)',
										opacity: 0.5,
										filter: 'blur(8px)',
									}}
								>
									<Avatar
										src={currentUser.avatar_url}
										w='100px'
										h='100px'
										borderRadius='12px'
										border='3px solid rgba(139, 92, 246, 0.5)'
										position="relative"
									/>
								</Box>
							</Flex>
							<Flex flexDirection='column' h='100%' p='22px' minW='60%' lineHeight='1.6'>
								<Text fontSize='sm' color='gray.400' fontWeight='bold'>
									Bienvenue sur l'intranet de la police de <Text as="span" color="purple.300">{config.tenantName}</Text>,
								</Text>
								<Text 
									fontSize='28px' 
									fontWeight='bold'
									bgGradient="linear(to-r, white, gray.200)"
									bgClip="text"
								>
									{currentUser ? currentUser.firstname : "[???]"} {currentUser ? currentUser.name : "[???]"}
								</Text>
								<Text fontSize='18px' color='gray.400' fontWeight='600'>
									{currentUser ? currentUser.grade : 'Agent'}
								</Text>
								<Spacer />
							</Flex>
							{/* Section pour le bouton */}
							{config.role("tribunal") && (
								<Flex w='40%' align='stretch' justify='flex-end'>
									<Button
										as={Link}
										to='/admin/new-arrest'
										// BACKGROUND : #1E0F58 -> #4855F9
										bg='linear-gradient(126.97deg, #1E0F58 28.26%, #4855F9 91.2%)'
										color='#fff'
										_active={{ bg: 'transparent' }}
										_focus={{ bg: 'transparent' }}
										_hover={{ transform: 'scale(1.05)', boxShadow: '0 0 15px rgba(255, 255, 255, 0.4)' }}
										h='100%'
										borderRadius='0 12px 12px 0'
										fontSize='lg'
										fontWeight='bold'
										w='100%'
										style={{
											transition: 'all 0.3s ease',
											display: 'flex',
											alignItems: 'center',
											animation: 'textWiggle 0.5s ease'
										}}
										onMouseEnter={e => {
											e.currentTarget.style.transform = 'scale(1)';
											e.currentTarget.style.animation = 'textWiggle 0.5s ease';
										}}
										onMouseLeave={e => {
											e.currentTarget.style.transform = 'scale(1)';
											e.currentTarget.style.animation = 'none';
										}}
									>
										<span style={{
											display: 'flex',
											alignItems: 'center',
											animation: `textWiggle 4s ease-in-out infinite alternate`
										}}>
											Nouvel acte
											<Icon as={BsArrowRight} ml='8px' />
										</span>
									</Button>

									<style>
										{`
										@keyframes textWiggle {
										0%, 100% { transform: translateX(0); }
										50% { transform: translateX(5px); }
										}
									`}
									</style>

								</Flex>
							)}
						</Flex>
					</CardBody>
				</Card>
				<Grid templateColumns={{ sm: '1fr', md: '1fr 1fr', '2xl': '2fr 2fr' }} my='26px' gap='18px'>
					{/* Nombre d'arrestations*/}
					<Card p='20px 0px 0px 0px' maxH='320px' animation={`${fadeInUp} 0.5s ease-out 0.6s both`}>
						<CardHeader mb='12px' ps='22px'>
							<Flex direction='column' alignSelf='flex-start'>
								<Text fontSize='md' color='#fff' fontWeight='bold' mb='4px'>
									Nombre de procès-verbaux rédigés durant les 30 derniers jours
								</Text>
								{totalArrestsLast30days > 0 ? (
									<Text fontSize='sm' fontWeight='medium' color='gray.400'>
										<Text as='span' color='green.400' fontWeight='bold'>
											+{totalArrestsLast30days} nouveaux PV
										</Text>{' '}
										depuis le {moment(nbrArrestsLastMonthPerDay[0].Date).format('LL')} jusqu'à aujourd'hui
									</Text>
								) : (
									<Text fontSize='sm' fontWeight='medium' color='gray.400'>
										<Text as='span' color='red.400' fontWeight='bold'>
											Aucun
										</Text>{' '}
										procès-verbal n'a été rédigé durant les 30 derniers jours
									</Text>
								)}
							</Flex>
						</CardHeader>
						{nbrArrestsLastMonthPerDay && nbrArrestsLastMonthPerDay.length > 0 ? (
							<Box w='100%' minH={{ sm: '200px' }} maxH='220px'>
								<LineChart
									datas={nbrArrestsLastMonthPerDay}
								/>
							</Box>
						) : (<Loading />)}
					</Card>
					{/* En service */}
					{usersDuty && usersDuty.length > 0 ? (
						<Card p='16px' maxH='320px' animation={`${fadeInUp} 0.5s ease-out 0.7s both`}>
							<CardHeader p='8px 0px 12px 0px'>
								<Flex direction='column'>
									<Text fontSize='md' color='#fff' fontWeight='bold' pb='4px'>
										Agents actuellement en service
									</Text>
									<Flex align='center'>
										<Icon as={IoCheckmarkDoneCircleSharp} color='teal.300' w={4} h={4} pe='3px' />
										<Text fontSize='sm' color='gray.400' fontWeight='normal'>
											<Text fontWeight='bold' as='span'>
												{stats ? stats.nbr_on_duty : '0'}
											</Text>{' '}
											agent(s) en service
										</Text>
									</Flex>
								</Flex>
							</CardHeader>

							<Box
								maxH='240px'
								overflowY='auto'
								css={{
									'&::-webkit-scrollbar': { width: '4px' },
									'&::-webkit-scrollbar-track': { background: 'transparent' },
									'&::-webkit-scrollbar-thumb': { background: '#582CFF', borderRadius: '4px' },
								}}
							>
								<Flex direction='column' gap='6px'>
									{usersDuty.map((row, index) => (
										<Flex
											key={index}
											align='center'
											p='8px 12px'
											bg='rgba(255, 255, 255, 0.03)'
											borderRadius='10px'
											_hover={{ bg: 'rgba(139, 92, 246, 0.1)' }}
											transition='all 0.2s'
										>
											<Avatar size='xs' src={row.avatar_url} mr='10px' />
											<Flex direction='column' flex='1' minW='0'>
												<Text fontSize='xs' color='#fff' fontWeight='600' isTruncated>
													{row.firstname} {row.name}
												</Text>
												<Text fontSize='xs' color='gray.500' isTruncated>
													{row.grade_name}
												</Text>
											</Flex>
											<Flex direction='column' align='flex-end' ml='8px'>
												<Text fontSize='xs' color='green.400' fontWeight='bold'>
													{row.total_arrests_since_last_service_start} PV
												</Text>
												<Text fontSize='10px' color='gray.500'>
													En service depuis le {row.last_service_start ? moment(row.last_service_start).format("DD MMMM yyyy à HH:mm") : "-"}
												</Text>
											</Flex>
										</Flex>
									))}
								</Flex>
							</Box>
						</Card>
					) : (
						// Aucun agent en service
						<Card p='16px' maxH='320px' animation={`${fadeInUp} 0.5s ease-out 0.7s both`}>
							<CardHeader p='8px 0px 12px 0px'>
								<Flex direction='column'>
									<Text fontSize='md' color='#fff' fontWeight='bold' pb='4px'>
										Agents actuellement en service
									</Text>
									<Flex align='center'>
										<Text fontSize='sm' color='gray.400' fontWeight='normal'>
											Tous les agents sont actuellement en repos
										</Text>
									</Flex>
								</Flex>
							</CardHeader>
						</Card>
					)}
				</Grid>
				{config.role("tribunal") && (
					<Grid templateColumns={{ sm: '1fr', md: '1fr 1fr', lg: '2fr 1fr' }} gap='24px'>
						{myArrestsInValidation && myArrestsInValidation.length > 0 ? (
							<Card p='16px' animation={`${fadeInUp} 0.5s ease-out 0.8s both`}>
								<CardHeader p='12px 0px 28px 0px'>
									<Flex direction='column'>
										<Text fontSize='lg' color='#fff' fontWeight='bold' pb='8px'>
											Mes actes en cours de validation
										</Text>
										<Flex align='center'>
											<Icon as={FaExclamationCircle} color='orange.300' w={4} h={4} pe='3px' />
											<Text fontSize='sm' color='gray.400' fontWeight='normal'>
												<Text fontWeight='bold' as='span'>
													{myArrestsInValidation.length}
												</Text>{' '}
												acte(s) sont encore en cours de validation
											</Text>
										</Flex>
									</Flex>
								</CardHeader>

								<div style={{
									maxHeight: '400px',
									overflowY: 'auto',
									scrollbarWidth: 'thin',
									scrollbarColor: '#582CFF transparent'
								}}>
									<Table variant='simple' color='#fff'>
										<Thead>
											<Tr my='.8rem' ps='0px'>
												<Th
													ps='0px'
													color='gray.400'
													fontFamily='Plus Jakarta Display'
													borderBottomColor='#56577A'>
													Citoyen
												</Th>
												<Th color='gray.400' fontFamily='Plus Jakarta Display' borderBottomColor='#56577A'>
													N° PV
												</Th>
												<Th color='gray.400' fontFamily='Plus Jakarta Display' borderBottomColor='#56577A'>
													Date
												</Th>
												<Th color='gray.400' fontFamily='Plus Jakarta Display' borderBottomColor='#56577A'>
													Status
												</Th>
											</Tr>
										</Thead>
										<Tbody>
											{myArrestsInValidation.map((row, index, arr) => {
												return (
													<TableMyArrests
														arrest={row}
														lastItem={index === arr.length - 1 ? true : false}
													/>
												);
											})}
										</Tbody>
									</Table>
								</div>
							</Card>
						) : (
							// Aucun agent en service
							<Card p='16px' animation={`${fadeInUp} 0.5s ease-out 0.8s both`}>
								<CardHeader p='12px 0px 28px 0px'>
									<Flex direction='column'>
										<Text fontSize='lg' color='#fff' fontWeight='bold' pb='8px'>
											Mes actes de procédure
										</Text>
										<Flex align='center'>
											<Icon as={FaCheckCircle} color='green.300' w={4} h={4} pe='3px' />
											<Text fontSize='sm' color='gray.400' fontWeight='normal'>
												Félicitation! tous vos actes de procédure ont été validés
											</Text>
										</Flex>
									</Flex>
								</CardHeader>
							</Card>
						)}
						{/*
				<Card p='16px'>
					<CardBody>
						<Flex direction='column' w='100%'>
							<Box
								bg='linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)'
								borderRadius='20px'
								display={{ sm: 'flex', md: 'block' }}
								justify={{ sm: 'center', md: 'flex-start' }}
								align={{ sm: 'center', md: 'flex-start' }}
								minH={{ sm: '180px', md: '220px' }}
								p={{ sm: '0px', md: '22px' }}>
								<BarChart
									barChartOptions={barChartOptionsDashboard}
									barChartData={barChartDataDashboard}
								/>
							</Box>
							<Flex direction='column' mt='24px' mb='36px' alignSelf='flex-start'>
								<Text fontSize='lg' color='#fff' fontWeight='bold' mb='6px'>
									Heures de service par agent
								</Text>
								<Text fontSize='md' fontWeight='medium' color='gray.400'>
									<Text as='span' color='green.400' fontWeight='bold'>
										+230 nouvelles arrestations
									</Text>{' '}
									depuis le début de l'année
								</Text>
							</Flex>
							<SimpleGrid gap={{ sm: '12px' }} columns={4}>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<WalletIcon h={'15px'} w={'15px'} color='#fff' />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											Services
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}
										color='#fff'
										fontWeight='bold'
										mb='6px'
										my='6px'>
										32,984
									</Text>
									<Progress colorScheme='brand' bg='#2D2E5F' borderRadius='30px' h='5px' value={20} />
								</Flex>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<RocketIcon h={'15px'} w={'15px'} color='#fff' />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											Clicks
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}
										color='#fff'
										fontWeight='bold'
										mb='6px'
										my='6px'>
										2.42m
									</Text>
									<Progress colorScheme='brand' bg='#2D2E5F' borderRadius='30px' h='5px' value={90} />
								</Flex>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<CartIcon h={'15px'} w={'15px'} color='#fff' />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											Sales
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}
										color='#fff'
										fontWeight='bold'
										mb='6px'
										my='6px'>
										2,400$
									</Text>
									<Progress colorScheme='brand' bg='#2D2E5F' borderRadius='30px' h='5px' value={30} />
								</Flex>
								<Flex direction='column'>
									<Flex alignItems='center'>
										<IconBox as='box' h={'30px'} w={'30px'} bg='brand.200' me='6px'>
											<StatsIcon h={'15px'} w={'15px'} color='#fff' />
										</IconBox>
										<Text fontSize='sm' color='gray.400'>
											Items
										</Text>
									</Flex>
									<Text
										fontSize={{ sm: 'md', lg: 'lg' }}
										color='#fff'
										fontWeight='bold'
										mb='6px'
										my='6px'>
										320
									</Text>
									<Progress colorScheme='brand' bg='#2D2E5F' borderRadius='30px' h='5px' value={50} />
								</Flex>
							</SimpleGrid>
						</Flex>
					</CardBody>
				</Card>
				*/}
						{/* Dernières arrestations */}
						<Card>
							<CardHeader mb='32px'>
								<Flex direction='column'>
									<Text fontSize='lg' color='#fff' fontWeight='bold' mb='6px'>
										Dernières rédactions
									</Text>
									<Flex align='center'>
										<Text fontSize='sm' color='gray.400' fontWeight='normal'>
											<Text fontWeight='bold' as='span' color='gray.400'>
												10
											</Text>{' '}
											dernières rédactions
										</Text>
									</Flex>
								</Flex>
							</CardHeader>
							<CardBody style={{
								maxHeight: '400px',
								overflowY: 'scroll',
								scrollbarWidth: 'thin',
								scrollbarColor: '#582CFF transparent'
							}}>
								<Flex direction='column' lineHeight='21px'>
									{lastArrests.length <= 0 && (
										<Text color='gray.400' mb='20px'>
											Aucune rédaction n'a été enregistrée pour le moment.
										</Text>
									)}
									{lastArrests.map((row, index, arr) => {
										return (
											<Stats_latestArrests
												arrest={row}
											/>
										);
									})}
								</Flex>
							</CardBody>
						</Card>
					</Grid>
				)}
				{/*
			<Grid
				templateColumns={{ sm: '1fr', lg: '1.7fr 1.3fr' }}
				maxW={{ sm: '100%', md: '100%' }}
				gap='24px'
				mb='24px'>
				<Card gridArea={{ md: '2 / 1 / 3 / 2', '2xl': 'auto' }}>
					<CardHeader mb='24px'>
						<Flex direction='column'>
							<Text color='#fff' fontSize='lg' fontWeight='bold' mb='4px'>
								Satisfaction Rate
							</Text>
							<Text color='gray.400' fontSize='sm'>
								From all projects
							</Text>
						</Flex>
					</CardHeader>
					<Flex direction='column' justify='center' align='center'>
						<Box zIndex='-1'>
							<CircularProgress
								size={200}
								value={80}
								thickness={6}
								color='#582CFF'
								variant='vision'
								rounded>
								<CircularProgressLabel>
									<IconBox mb='20px' mx='auto' bg='brand.200' borderRadius='50%' w='48px' h='48px'>
										<Icon as={BiHappy} color='#fff' w='30px' h='30px' />
									</IconBox>
								</CircularProgressLabel>
							</CircularProgress>
						</Box>
						<Stack
							direction='row'
							spacing={{ sm: '42px', md: '68px' }}
							justify='center'
							maxW={{ sm: '270px', md: '300px', lg: '100%' }}
							mx={{ sm: 'auto', md: '0px' }}
							p='18px 22px'
							bg='linear-gradient(126.97deg, rgb(6, 11, 40) 28.26%, rgba(10, 14, 35) 91.2%)'
							borderRadius='20px'
							position='absolute'
							bottom='5%'>
							<Text fontSize='xs' color='gray.400'>
								0%
							</Text>
							<Flex direction='column' align='center' minW='80px'>
								<Text color='#fff' fontSize='28px' fontWeight='bold'>
									95%
								</Text>
								<Text fontSize='xs' color='gray.400'>
									Based on likes
								</Text>
							</Flex>
							<Text fontSize='xs' color='gray.400'>
								100%
							</Text>
						</Stack>
					</Flex>
				</Card>
				<Card gridArea={{ md: '2 / 2 / 3 / 3', '2xl': 'auto' }}>
					<Flex direction='column'>
						<Flex justify='space-between' align='center' mb='40px'>
							<Text color='#fff' fontSize='lg' fontWeight='bold'>
								Secteur [SECTEUR]
							</Text>
							<Button borderRadius='12px' w='38px' h='38px' bg='#22234B' _hover='none' _active='none'>
								<Icon as={IoEllipsisHorizontal} color='#7551FF' />
							</Button>
						</Flex>
						<Flex direction={{ sm: 'column', md: 'row' }}>
							<Flex direction='column' me={{ md: '6px', lg: '52px' }} mb={{ sm: '16px', md: '0px' }}>
								<Flex
									direction='column'
									p='22px'
									pe={{ sm: '22e', md: '8px', lg: '22px' }}
									minW={{ sm: '220px', md: '140px', lg: '220px' }}
									bg='linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)'
									borderRadius='20px'
									mb='20px'>
									<Text color='gray.400' fontSize='sm' mb='4px'>
										Utilisateurs
									</Text>
									<Text color='#fff' fontSize='lg' fontWeight='bold'>
										145 agents
									</Text>
								</Flex>
								<Flex
									direction='column'
									p='22px'
									pe={{ sm: '22px', md: '8px', lg: '22px' }}
									minW={{ sm: '170px', md: '140px', lg: '170px' }}
									bg='linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)'
									borderRadius='20px'>
									<Text color='gray.400' fontSize='sm' mb='4px'>
										Bonus
									</Text>
									<Text color='#fff' fontSize='lg' fontWeight='bold'>
										1,465
									</Text>
								</Flex>
							</Flex>
							<Box mx={{ sm: 'auto', md: '0px' }}>
								<CircularProgress
									size={window.innerWidth >= 1024 ? 200 : window.innerWidth >= 768 ? 170 : 200}
									value={70}
									thickness={6}
									color='#05CD99'
									variant='vision'>
									<CircularProgressLabel>
										<Flex direction='column' justify='center' align='center'>
											<Text color='gray.400' fontSize='sm'>
												Safety
											</Text>
											<Text
												color='#fff'
												fontSize={{ md: '36px', lg: '50px' }}
												fontWeight='bold'
												mb='4px'>
												9.3
											</Text>
											<Text color='gray.400' fontSize='sm'>
												Total Score
											</Text>
										</Flex>
									</CircularProgressLabel>
								</CircularProgress>
							</Box>
						</Flex>
					</Flex>
				</Card>
			</Grid>
						*/}
			</Flex>
		</>
	);
}
